import BaseComponent from '@/components/base';
import ShopifyAPI from '@/gateway/ShopifyAPI';
import quantityInputStyle from '@/components/quantity-input/style';
import MinusButton from '@/components/minus-button';
import plusButton from '@/components/plus-button';

export default class QuantityInput extends BaseComponent {
  render() {
    return `
    ${quantityInputStyle()}
        <div class="cart-quantity-container">
            <button class="quantity-button quantity-button-minus" name="minus" type="button" data-button="minus">
              ${MinusButton()}
            </button>
            <input
              class="quantity-input"
              data-quantity-variant-id="${this.itemVariantId}"
              data-line-item-key="${this.itemKey}"
              type="number"
              name="updates[]"
              value="${this.itemQuantity}"
              data-cart-quantity="${this.cartQuantity}"
              min="1"
              data-min="${this.quantityMin}"
              max =  ${this.quantityMax != null ? this.quantityMax : null}
              step="${this.quantityIncrement}"
              {% # theme-check-enable %}
              id="Quantity-${this.itemIndexPlus}"
              data-index="${this.itemIndexPlus}"
            >
            <button class="quantity-button quantity-button-plus" name="plus" type="button" data-button="plus">
               ${plusButton()}
            </button>
          </div>`;
  }

  connectedCallback() {
    this.connectChangeQuantityButtons();
    this.connectChangeInputQuantity();
  }

  removeProductCart(productVariantId) {
    const productCartDetails = document.querySelectorAll(
      `div[data-id="${productVariantId}"]`
    );
    productCartDetails.forEach((element) => {
      element.remove();
    });
  }

  async handleChangeQuantity(addQuantity) {
    const quantityInputField = this.shadowRoot.querySelector(
      '[data-cart-quantity]'
    );
    const lineItemKey = quantityInputField.getAttribute('data-line-item-key');
    const productQuantityValue = Number(quantityInputField.value);
    const newProductQuantity = productQuantityValue + addQuantity;
    const productToAdd = {
      id: lineItemKey,
      quantity: newProductQuantity
    };
    const mainContent = document.querySelector('#MainContent');
    const mainSection = mainContent.firstElementChild;
    const maindIdFormatted = mainSection.id.replace('shopify-section-', '');
    quantityInputField.value = `${newProductQuantity}`;
    quantityInputField.setAttribute(
      'data-cart-quantity',
      `${newProductQuantity}`
    );
    try {
      await ShopifyAPI.changeCart(productToAdd);
    } catch (error) {
      console.log('error =>', error);
    } finally {
      await ShopifyAPI.updateSection(maindIdFormatted);
    }
    if (newProductQuantity <= 0) {
      this.removeProductCart(lineItemKey);
    }
  }

  async handleChangeQuantityInput(value) {
    const quantityInputField = this.shadowRoot.querySelector(
      '[data-cart-quantity]'
    );
    const lineItemKey = quantityInputField.getAttribute('data-line-item-key');
    const newProductQuantity = Number(value);
    const productToAdd = {
      id: lineItemKey,
      quantity: newProductQuantity
    };
    const mainContent = document.querySelector('#MainContent');
    const mainSection = mainContent.firstElementChild;
    const maindIdFormatted = mainSection.id.replace('shopify-section-', '');
    quantityInputField.value = `${newProductQuantity}`;
    quantityInputField.setAttribute(
      'data-cart-quantity',
      `${newProductQuantity}`
    );
    try {
      await ShopifyAPI.changeCart(productToAdd);
    } catch (error) {
      console.log('error =>', error);
    } finally {
      await ShopifyAPI.updateSection(maindIdFormatted);
    }
    if (newProductQuantity <= 0) {
      this.removeProductCart(lineItemKey);
    }
  }

  connectChangeQuantityButtons() {
    const buttonPlus = this.shadowRoot.querySelector('[data-button="plus"]');
    const buttonMinus = this.shadowRoot.querySelector('[data-button="minus"]');
    buttonPlus.addEventListener('click', () => this.handleChangeQuantity(+1));
    buttonMinus.addEventListener('click', () => this.handleChangeQuantity(-1));
  }

  connectChangeInputQuantity() {
    const inputQuantity = this.shadowRoot.querySelector('[data-cart-quantity]');

    inputQuantity.addEventListener('blur', (e) =>
      this.handleChangeQuantityInput(e.target.value)
    );
  }

  get itemQuantity() {
    return this.getAttribute('quantity');
  }

  get itemVariantId() {
    return this.getAttribute('variantId');
  }

  get itemKey() {
    return this.getAttribute('lineItemKey');
  }

  get cartQuantity() {
    return this.getAttribute('cartQuantity');
  }

  get quantityMin() {
    return this.getAttribute('quantityMin');
  }

  get itemIndexPlus() {
    return this.getAttribute('itemIndexPlus');
  }

  get quantityMax() {
    return this.getAttribute('quantityMax');
  }

  get quantityIncrement() {
    return this.getAttribute('quantityIncrement');
  }
}
